import React, { FC } from 'react';
import { Feather } from '@expo/vector-icons';
import { View } from 'react-native';

import { Body1Bold, Body2Reg } from '../../../config/designSystem/typography';
import { COLORS } from '../../../config/designSystem/Colors';
import { SPACING } from '../../../config/designSystem/Spacing';

interface InfoCardProps {
  title: string;
  body: string;
}

/** The "What else should I add?" helper card under diary forms. */
export const InfoCard: FC<InfoCardProps> = ({ title, body }) => {
  return (
    <View
      style={{
        backgroundColor: COLORS.surface.accent,
        borderRadius: SPACING['sp-16'],
        padding: SPACING['sp-16'],
        rowGap: SPACING['sp-8'],
      }}
    >
      <View style={{ flexDirection: 'row', alignItems: 'center', columnGap: SPACING['sp-8'] }}>
        <Feather name="help-circle" size={18} color={COLORS.content.accent} />
        <Body1Bold color={COLORS.content.accent}>{title}</Body1Bold>
      </View>
      <Body2Reg color={COLORS.content.secondary}>{body}</Body2Reg>
    </View>
  );
};
